import React from 'react';
var context = React.createContext(null);
context.displayName = 'CardContext';
export default context;